import React from 'react'
import { CustomModal } from 'components/molecules/Modal/Modal'
import { Box } from '@mui/material'
import { Visibility } from '@mui/icons-material'
import styles from './ImplantReportPreviewModal.module.scss'
import { ImplantReportPreviewModalProps } from './ImplantReportPreviewModal.types'

export const ImplantReportPreviewModal: React.FC<
  ImplantReportPreviewModalProps
> = ({ open, onClose, pdfUrl, reportType, isLoading }) => {
  return (
    <CustomModal
      open={open}
      closeButtonOnly
      header={`${reportType} Report Preview`}
      isLoadingState={isLoading}
      secondaryButtonAction={onClose}
      icon={<Visibility />}
      fitContentWidth={false}
    >
      <Box className={styles.previewContainer}>
        {pdfUrl ? (
          <div
            className={styles.pdfPreview}
            title={`${reportType} Report Preview`}
            dangerouslySetInnerHTML={{
              __html: pdfUrl,
            }}
          />
        ) : (
          <Box className={styles.loadingContainer}>Loading preview...</Box>
        )}
      </Box>
    </CustomModal>
  )
}
